<ng-container *ngIf="authService.isLogged()">
  <div [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="horizontal"></fuse-navigation>
  </div>
</ng-container>

<!-- Bandeau Haut pour le mode public !! -->
<ng-container *ngIf="!authService.isLogged()">
  <div appFlexLayout="row" appFlexAlign="space-between center" style="height: 56px;" class="accent w-100-p p-4">
    <div (click)="goInbeWebsite()" appFlex="grow" class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
      <img src="assets/images/logos/logo-text_white.svg" alt="">
    </div>
    <div appFlex="grow">

    </div>

    <div *ngIf="canUserChangeLang" appFlex="auto" style="width: 64px;" class="mr-8">
      <app-language-selector [(lang)]="curLang" (langChange)="setLanguage($event)"></app-language-selector>
    </div>

    <div appFlex="auto">
      <button (click)="goHome()" mat-stroked-button>{{'Se connecter' | translate}}</button>
    </div>
  </div>
</ng-container>
